import { useEffect, useState } from "react"
import { useFilter } from "../../../../../../../../hooks/filter"
import { formatFilter, trackingInput } from "../../constants"
import { formatTrackingForm } from "../../formaters"
import { useReassignUserContext } from "../../context"
import { SearchAndAddUser } from "../searchAndAddUser"

export const ManageUserFilter = () => {
    const { state, services } = useReassignUserContext()
    const { items } = state
    const [input, setInput] = useState(trackingInput)
    const filterData = useFilter({
        formatFilter,
        externalValidation: (payload) => {
            const { body, department } = formatTrackingForm({ ...payload, items: { department: items.department } })
            if (payload.name == 'area') {
                setInput(prev => ({ ...prev, department: { ...prev.department, items: department }, }))
            }
            return body
        }
    })

    const searchUser = () => { services.searchUsersToTracking({ query: filterData.query }) }
    useEffect(() => {
        const { items: { area, role, userType, } } = state
        setInput(prev => ({ ...prev, area: { ...prev.area, items: area }, role: { ...prev.role, items: role }, userType: { ...prev.userType, items: userType }, }))
    }, [items])
    return (
        <SearchAndAddUser
            form={{
                input: Object.values(input),
                values: filterData.filterData,
                onChange: filterData.onChange
            }}
            cancel={{ onClick: filterData.cleanFilter }}
            confirm={{ onClick: searchUser }}
        />
    )
}